import { useRef } from 'react';

import useIsomorphicLayoutEffect from '@common/hooks/useIsomorphicLayoutEffect';
import { useHistoryLengthContext } from '@common/contexts/historyLengthContext';

export const useProductListScrollRestore = (
  productsGridRef,
  executeOnDependency = false,
  executeOnMount = true,
) => {
  const { previousUrl, disableScrollRestoration } = useHistoryLengthContext();
  const isScrolledRestored = useRef(false);

  useIsomorphicLayoutEffect(disableScrollRestoration, []);

  useIsomorphicLayoutEffect(() => {
    if (
      (executeOnDependency || executeOnMount) &&
      !isScrolledRestored.current &&
      previousUrl &&
      productsGridRef.current
    ) {
      const { groups: { productId, colorId } = {} } =
        previousUrl.match(/\/(?<productId>\d+)-(?<colorId>\d+)\/?$/) || {};

      const matchedProducts = [...productsGridRef.current.children]
        .filter(el => el.dataset.id.startsWith(productId))
        .map(el => [el, ...el.dataset.id.split('-')]);

      if (!matchedProducts.length) return;

      let [product] = matchedProducts[0];

      if (matchedProducts.length > 1) {
        [product] =
          matchedProducts.find(
            ([, , matchedColorId]) => matchedColorId === colorId,
          ) || matchedProducts[0];
      }

      window.scrollTo(0, product.offsetTop);
      isScrolledRestored.current = true;
    }
  }, [executeOnDependency, executeOnMount]);
};
